import { render, staticRenderFns } from "./IvaLibroDigital.vue?vue&type=template&id=82af8b40&"
import script from "./IvaLibroDigital.vue?vue&type=script&lang=js&"
export * from "./IvaLibroDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports